module.exports = __webpack_public_path__ + "static/media/more-options-dark.291dd942.svg";